module.exports = __webpack_public_path__ + "img/data.a23431c5.svg";